/**
 * Component: Site navigation
 * ------------------------------------------------------------------------------
 * The meganav dropdown for vehicles.
 *
 * @namespace siteNav
 */

import log from 'salvo-lite/log'
import cssClasses from '../helpers/cssClasses'
import {on} from '../helpers/utils'

class SiteNav {
    constructor (theme, elem) {
        this._theme = theme
        this._elem = elem
        this._settings = {
            ...JSON.parse(elem.getAttribute('data-sitenav') || '{}')
        }
        this._categoryTab = [...document.querySelectorAll('[data-vehicle-nav="category"]')]
        this._modelBlock = [...document.querySelectorAll('[data-vehicle-nav="model"]')]
        this._dateListLink = [...document.querySelectorAll('[data-vehicle-nav="year"]')]
        log.debug(this.constructor.name, 'Constructed', this)
    }

    /**
   * Initialise component.
   */
    onInit () {
        this._setListeners()
    }

    /**
     * Set nav dropdown listeners.
     */
    _setListeners () {
        window.Frame.EventBus.listen('Toggle:navDropdownTarget:open', () => this._addBodyClass())
        window.Frame.EventBus.listen('Toggle:navDropdownToggle:close', () => this._removeBodyClass())

        window.Frame.EventBus.listen('Toggle:navDropdownTargetVehicle:open', () => this._addBodyClass())
        window.Frame.EventBus.listen('Toggle:navDropdownToggleVehicle:close', () => this._removeBodyClass())

        window.Frame.EventBus.listen('Toggle:navDropdownTargetAccessories:open', () => this._addBodyClass())
        window.Frame.EventBus.listen('Toggle:navDropdownToggleAccessories:close', () => this._removeBodyClass())

        window.Frame.EventBus.listen('Toggle:navDropdownTargetMega:open', () => this._addBodyClass())
        window.Frame.EventBus.listen('Toggle:navDropdownToggleMega:close', () => this._removeBodyClass())

        this._categoryTab.forEach((item) => {
            on('click', item, (event) => this._handleCategoryTabClick(event, item))
        })

        this._modelBlock.forEach((item) => {
            on('click', item, (event) => this._handlemodelBlockClick(event, item))
        })

        this._dateListLink.forEach((item) => {
            on('click', item, (event) => this._handleDateListLinkClick(event, item))
        })
    }

    /**
     * Add body classes on nav toggle.
     */
    _addBodyClass () {
        document.body.classList.add('site-nav--open')
        this._removeActiveDataListLink()
    }

    /**
     * Remove body classes on nav toggle.
     */
    _removeBodyClass () {
        document.body.classList.remove('site-nav--open')
        this._removeActiveDataListLink()
    }

    /**
     * Vehicle column toggle functions.
     * @param {Event} event the click event.
     * @param {Object} element the clicked element.
     */
    _handleCategoryTabClick (event, element) {
        event.stopImmediatePropagation()
        event.preventDefault()

        if (!element.classList.contains(cssClasses.active)) {
            this._removeActiveDataListLink()
            this._removeActiveCategory()
            element.classList.add(cssClasses.active)
        }
    }

    /**
     * Vehicles dropdown active class toggling.
     * @param {Event} event the click event.
     * @param {Object} element the clicked element.
     */
    _handlemodelBlockClick (event, element) {
        event.preventDefault()

        this._modelBlock.forEach((item) => {
            if (item === element) {
                item.classList.toggle(cssClasses.active)
                return
            }

            item.classList.remove(cssClasses.active)
        })
    }

    /**
     * Vehicle date list item window location redirect.
     * - Follows the target through if data-target is true.
     * @param {Object} element the clicked element.
     */
    _handleDateListLinkClick (event, element) {
        // Prevent cmd and ctrl key new tabbing
        if (event.metaKey || event.ctrlKey) {
            return
        }

        event.preventDefault()

        const allYears = element.getAttribute('data-years')
        const yearTarget = element.getAttribute('data-target')

        const modelYear = {
            model: element.getAttribute('data-model'),
            year: element.getAttribute('data-year'),
            years: allYears
        }

        window.Frame.EventBus.emit('CurrentCar:setCar', modelYear)

        if (yearTarget === 'true') {
            window.location.href = element.href
            return
        }

        if (window.location.pathname === '/collections/all') {
            window.Frame.EventBus.emit('Overlay:navDropdownTarget:hide')

            // Hide menu drawer after delay so you can see current car has updated
            window.setTimeout(() => {
                window.Frame.EventBus.emit('Overlay:menuDrawerTarget:hide')
            }, 1000)
        } else {
            window.Frame.EventBus.emit('CurrentCar:redirect', 'collection')
        }
    }

    /**
     * Remove vehicle classes.
     */
    _removeActiveCategory () {
        this._categoryTab.forEach((element) => {
            element.classList.remove(cssClasses.active)
        })
    }

    /**
     * Remove date list classes.
     */
    _removeActiveDataListLink () {
        this._modelBlock.forEach((element) => {
            element.classList.remove(cssClasses.active)
        })
    }

    /**
     * Expose public interface.
     */
    // return Object.freeze({
    //     init,
    // });
}

export default SiteNav



// WEBPACK FOOTER //
// ./src/resources/scripts/components/SiteNav.js